module.exports = __webpack_public_path__ + "media/bootstrap-icons/caret-right-0a69d866.svg";